import DriveEtaIcon from '@mui/icons-material/DriveEta'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import HubIcon from '@mui/icons-material/Hub'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import ParkingIcon from '@mui/icons-material/LocalParking'
import { Box } from '@mui/material'
import { isEmpty } from 'lodash'
import React from 'react'

import GoogleMap from '../vendor/googlemaps'

export const getFormattedPosition = (position) => ({
  lat: position.lat ?? position.latitude,
  lng: position.lng ?? position.longitude,
})

const ICON_MAP = {
  normal: { icon: FiberManualRecordIcon, color: '#3498db', size: 24 },
  parking: { icon: ParkingIcon, color: '#3a7afe', size: 42 },
  fueling: { icon: LocalGasStationIcon, color: '#00b894', size: 42 },
  last: { icon: DriveEtaIcon, color: '#3296A0', size: 42 },
  hub: { icon: HubIcon, color: '#0578f1', size: 36 },
}

export const MapMarkerIcon = ({ type, ...record }) => {
  const { icon: IconComp, color, size } = ICON_MAP[type] || ICON_MAP.normal
  const isEvent = ['hub', 'parking', 'fueling', 'last'].includes(type)

  const bgColor = color
  const iconColor = isEvent ? 'white' : color

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: isEvent ? bgColor : 'transparent',
        boxShadow: isEvent ? '0 1px 3px rgba(0,0,0,0.25)' : 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <IconComp
        fontSize="small"
        sx={{
          color: isEvent ? 'white' : iconColor,
          fontSize: size * 0.6,
        }}
      />
    </Box>
  )
}

export const getMapMarker = (position, type, info) => {
  if (!position) return null

  return {
    position: {
      lat: position.lat ?? position.latitude,
      lng: position.lng ?? position.longitude,
    },
    Icon: MapMarkerIcon,
    markerType: type,
    ...info,
  }
}

export const getMapCircle = (geofencing, position, type = 'hub') => ({
  radius: geofencing,
  center: getFormattedPosition(position),
  type: type,
})

const Map = ({ height = 360, markers, circles, polylines }) => {
  const validMarkers = markers?.filter(
    ({ position } = {}) => Number.isFinite(position?.lat) && Number.isFinite(position?.lng),
  )
  const shouldRenderGoogleMap = import.meta.env.VITE_DISABLE_GOOGLE_MAP_RENDERING !== 'true'

  return (
    <Box data-testid="mapContainer" sx={{ position: 'relative', width: '100%', height }}>
      {shouldRenderGoogleMap && !isEmpty(validMarkers) ? (
        <GoogleMap markers={validMarkers} circles={circles} polylines={polylines} />
      ) : null}
    </Box>
  )
}

export default Map
